import { Chip } from '@mui/material'

interface ComingSoonChipProps {
  label: string
}

export function ComingSoonChip({ label }: ComingSoonChipProps) {
  return (
    <Chip
      label={label}
      variant="outlined"
      size="small"
      sx={{
        borderRadius: '999px',
        color: 'info.dark',
        borderColor: 'info.dark',
        fontWeight: 600,
        textTransform: 'uppercase',
        margin: '-35px -14px -8px',
        '& .MuiChip-label': {
          lineHeight: 'normal'
        }
      }}
    />
  )
}
